module.exports = __webpack_public_path__ + "img/8.00de842c.png";